/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

export interface ICustomNavigationMenuData {
    actionResponse: { text: string };
}

export interface IMenuItemData {
    id?: number;
    linkText?: string;
    linkURL?: string;
    imageSource?: string;
    imageDestinationURL?: string;
    subMenu?: IMenuItemData[];
    menuSource?: string;
    shouldOpenNewTab?: boolean;
    ariaLabel?: string;
}

export enum MenuTypeIndexId {
    Cms = 2000,
    Retail = 6000
}